



































import { Component, Mixins } from 'vue-property-decorator';
import { TjipFormGroupMixin, TjipFormItemTextMixin, TjipFormGroupValueMixin } from '@tjip/vuejs';
import AppFormControlTelefoonnummerComponent from './AppFormControlTelefoonnummer.vue';

@Component({})
export class AppFormGroupTelefoonnummerComponent extends Mixins(
  TjipFormGroupValueMixin,
  TjipFormItemTextMixin,
  TjipFormGroupMixin
) {
  get control(): AppFormControlTelefoonnummerComponent {
    return this.$refs.control as AppFormControlTelefoonnummerComponent;
  }
}

export default AppFormGroupTelefoonnummerComponent;
